import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { pathSteps } from '../../data/content';
export function Bridge() {
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-20" data-id="element-161" data-mp="kvq7dzmcnt2d">
      <div className="mx-auto max-w-3xl" data-id="element-162" data-mp="ktwzkh0032ss">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-[1.15] text-navy-deep sm:text-4xl" data-id="element-163" data-mp="fwx0wr5hd2bp">
          Non hai bisogno di memorizzare centinaia di pagine di KDIGO.
        </h2>
        <p className="mt-4 text-center text-[16px] font-semibold leading-relaxed text-kidney-dark sm:text-xl" data-id="element-164" data-mp="66bwuo71f5le">
          Hai bisogno di un percorso che trasformi le evidenze in decisioni cliniche.
        </p>
        <p className="mx-auto mt-5 max-w-2xl text-center text-[14.5px] leading-relaxed text-navy/75 sm:text-base" data-id="element-165" data-mp="3tccmgs5hknqh">
          È esattamente ciò che fa Percorso Malattia Renale™. Invece di darti un altro
          enorme manuale da leggere dall’inizio alla fine, ti offre un sistema
          strutturato intorno alle decisioni che affronti realmente nella pratica
          clinica.
        </p>

        <ol className="mx-auto mt-9 flex max-w-sm flex-col items-stretch sm:mt-12" data-id="element-166" data-mp="269voen8g9nmb">
          {pathSteps.map((step, index) => <li key={step} className="flex flex-col items-center" data-id="element-167" data-mp="1sjijyuuror1q" data-mpi={index}>
              <div className="flex w-full items-center gap-3 rounded-2xl border border-navy-deep/10 bg-white px-4 py-3.5" data-id="element-168" data-mp="1xgimwwwbldom">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-kidney text-[12px] font-extrabold text-white" data-id="element-169" data-mp="2l7xvh7eowr8b">
                  {index + 1}
                </span>
                <span className="text-[14.5px] font-bold leading-snug text-navy-deep sm:text-base" data-id="element-170" data-mp="2b7njtr8azrv9">
                  {step}
                </span>
              </div>
              {index < pathSteps.length - 1 ? <ArrowDownIcon className="my-1.5 h-4 w-4 text-kidney" aria-hidden="true" data-id="element-171" data-mp="zryu4s3o0eqr" /> : null}
            </li>)}
        </ol>

        <div className="mx-auto mt-9 max-w-md sm:mt-12" data-id="element-172" data-mp="kph1fvjcrujx">
          <CtaButton label="Voglio eliminare questi dubbi oggi" sub="Accesso immediato • Garanzia di 7 giorni" data-id="element-173" data-mp="goezh6y1x4e9" />
        </div>
      </div>
    </section>;
}